import { useQuery } from '@tanstack/react-query';
import { useForBindingId } from '../../../forBinding';
import type { FertilizationPlanAdvice } from '../../../recommendations/types';
import api from '../../http';

export function useGetAdviceMaintenanceById(id: string) {
	const forBinding = useForBindingId();
	return useQuery({
		queryKey: ['maintenance', id],
		queryFn: async () => {
			const { data } = await api.get<FertilizationPlanAdvice>(
				`/advices/fertilization-plan/get/${id}`,
				{
					params: { forBinding },
				}
			);
			return data;
		},
		enabled: !!id,
	});
}
